import { UpperCasePipe } from '@angular/common';
import {
  Component,
  ViewEncapsulation,
  EventEmitter,
  OnInit,
  Output
} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { AppSettings } from '../../app.settings';
import { UserCommonApiService } from '@App/common/services';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { TranslateModule } from '@ngx-translate/core';
import { NoLeadingSpaceDirective } from '@App/common/directives';

@Component({
  selector: 'app-contact-modal',
  templateUrl: './contact-modal.component.html',
  styleUrls: ['./contact-modal.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    InputMaskModule,
    InputTextModule,
    UpperCasePipe,
    NoLeadingSpaceDirective
  ],
  encapsulation: ViewEncapsulation.None
})
export class ContactModalComponent implements OnInit {
  @Output() hideModal = new EventEmitter<string>();
  @Output() submitForm = new EventEmitter<{ data: any }>();

  contactForm: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private userCommonService: UserCommonApiService
  ) {}

  ngOnInit(): void {
    this.formInit();
  }

  formInit() {
    const profile = this.userCommonService;
    const isAuthUser = this.userCommonService.isAuthenticated();
    this.contactForm = this.formBuilder.group({
      firstName: [
        isAuthUser ? profile?.userFirstName : null,
        [Validators.required, Validators.min(4)]
      ],
      lastName: [
        isAuthUser ? profile.userLastName : null,
        [Validators.required, Validators.min(4)]
      ],
      mobileNumber: [
        isAuthUser ? profile?.userContactNumber : null,
        [Validators.required]
      ],
      emailId: [
        isAuthUser ? profile?.userEmailId : null,
        [Validators.required, Validators.pattern(AppSettings.EMAIL_PATTERN)]
      ],
      companyName: [null, [Validators.required, Validators.min(4)]]
    });
  }

  onCancelButtonClick() {
    this.hideModal.emit();
  }

  onContactButtonClick() {
    const { lastName, firstName, companyName, emailId, mobileNumber } =
      this.contactForm.controls;
    this.submitForm.emit({
      data: {
        lastName: lastName.value,
        firstName: firstName.value,
        companyName: companyName.value,
        emailId: emailId.value,
        mobileNumber: mobileNumber.value
      }
    });
  }
}
